import { call, put, select } from 'redux-saga/effects';
import { IBets, IClientBet } from 'widgets/Roulette/types';
import { placedBetSelector } from '../selectors';
import { init, last, pick } from 'ramda';
import { refreshBetsSaga, ServerBetsType } from './refreshBetsSaga';
import { isTheLast2SecondsInBettingTimeSelector } from '../../BettingTime';
import { IRoundState, RoundStates } from '../../RoundStates/types';
import { roundStateSelector } from '../../RoundStates';
import { clearDoubleBetAction } from '../../BetDouble/actions';
import { clearRepeatBetAction } from '../../BetRepeat/actions';
import { ICreatePendingBetRequestData, RestService } from 'services/RestAPIService';
import { setTotalBetAction } from '../../User/actions';
import { refreshBetsAction } from '../actions';
import * as Sentry from '@sentry/react';
import { betsToBetsArray, sumBets } from 'widgets/Roulette/helpers';
import { BetsTypes, raceTrackBets } from 'widgets/Roulette/const';

export function* cancelLastBetSaga() {
  const isTheLast2SecondsInBettingTime: boolean = yield select(
    isTheLast2SecondsInBettingTimeSelector,
  );
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);

  const currentBets: IBets = yield select(placedBetSelector);
  const { past, future } = currentBets;
  const lastPast = last(past);

  const newPast = lastPast ? init(past) : [];
  // @ts-ignore
  const betsArray: IClientBet[] = betsToBetsArray(lastPast || {});

  if (!isTheLast2SecondsInBettingTime) {
    yield refreshBetsSaga({
      past: newPast,
      present: betsArray,
      future,
    });
    yield put(clearDoubleBetAction());
    yield put(clearRepeatBetAction());
  }

  if (isTheLast2SecondsInBettingTime) {
    if (roundState === RoundStates.BettingTimeStarted) {
      const baseProps = ['type', 'bet', 'selector'];

      const betsForServer: ServerBetsType = betsArray.reduce(
        (acc: ServerBetsType, clientBet: IClientBet) => {
          const { type, bet, label } = clientBet;

          if (!bet) return acc;

          // @ts-ignore
          const modifiedBet = pick(baseProps, clientBet);

          const isColumnOrDozen = type === BetsTypes.column || type === BetsTypes.dozen;

          const serverBet = isColumnOrDozen
            ? { ...modifiedBet, item: Number(label?.slice(0, 1)) }
            : modifiedBet;

          const isInfoBet =
            raceTrackBets.has(type) ||
            type === BetsTypes.historyStraight ||
            type === BetsTypes.hotColdStraight;

          return isInfoBet
            ? { ...acc, info: [...acc.info, modifiedBet] }
            : { ...acc, bets: [...acc.bets, serverBet] };
        },
        { bets: [], info: [] },
      );

      const betsData: ICreatePendingBetRequestData = {
        bets: betsForServer.bets,
        info: betsForServer.info,
        timeStamp: new Date().getTime(),
      };

      try {
        const response: ICreatePendingBetRequestData = yield call(() =>
          RestService.createPendingBet(betsData),
        );

        const totalBet = sumBets(betsForServer.bets);
        yield put(setTotalBetAction(totalBet));
        yield put(
          refreshBetsAction({
            past: newPast,
            present: lastPast || {},
            future,
          }),
        );
      } catch (error) {
        Sentry.captureException({ error, betsData });
        console.log(error);
      }
    }
  }
}
